export class GetSupplierSalesLocationRequest {
  fromDate: string | undefined;
  toDate: string | undefined;
  requestDateArray?: Date[] | null | undefined;
  supplierIds: string[] | undefined;
}
export class GetSupplierSalesLocationResponseDATA {
  data: GetSupplierSalesLocationResponse[] | undefined;
  tree: Tree | undefined;
  minWeight: number | undefined;
  maxWeight: number | undefined;
}
export class Tree {
  totalCount: number | undefined;
  totalAmount: number | undefined;
  title: string | undefined;
  provinces: Provinces[] | undefined;
}
export class Provinces {
  totalCount: number | undefined;
  totalAmount: number | undefined;
  provinceTitle: string | undefined;
  objectId: number | undefined;
  cities: Cities[] | undefined;
}
export class Cities {
  objectId: number | undefined;
  totalCount: number | undefined;
  totalAmount: number | undefined;
  cityTitle: string | undefined;
  suppliers: Suppliers[] | undefined;
}
export class Suppliers {
  objectId: number | undefined;
  count: number | undefined;
  amount: number | undefined;
  supplierTitle: string | undefined;
  lat: number | undefined;
  lng: number | undefined;
}
export class GetSupplierSalesLocationResponse {
  supplierTitle: string | undefined;
  provinceTitle: string | undefined;
  cityTitle: string | undefined;
  lat: number | undefined;
  lng: number | undefined;
  weight: number | undefined;
  salesInfos: SalesInfos[] | undefined;
  colorCode: string | undefined;
}
export interface SalesInfos {
  title: string;
  count: number;
  totalAmount: number;
}
